module.exports = __webpack_public_path__ + "img/quote-avatar@2x.7a4905b1.png";